/** ************************
 * HELPERS
 */

import { getIndex } from './util/indexMap';

const {
	parseTimeuuid,
	parseOriginalFileName
} = require('./util/parse.gpsFilePath');

const selectSliceCisview = state => {
	if (state?.cisview) {
		return state.cisview;
	}
	return state;
};

const selectSliceJob = state => {
	const slice = selectSliceCisview(state);
	if (slice?.job) {
		return slice.job;
	}
	return slice;
};

const selectJobGlobalData = state => {
	const slice = selectSliceJob(state);
	return slice.globalData;
};

const selectSliceAdditionalSurveys = state => {
	const slice = selectSliceCisview(state);
	if (slice?.additionalSurveys) {
		return slice.additionalSurveys;
	}
	return slice;
};

const selectConvertedReadingsKeyToIndexesByTimeuuid = (state, timeuuid) => {
	const additionalSurveys = selectSliceAdditionalSurveys(state);
	return additionalSurveys.convertedReadingsKeyToIndexesByTimeuuid[timeuuid];
};

const selectConvertedReadingsByTimeuuid = (state, timeuuid) => {
	const additionalSurveys = selectSliceAdditionalSurveys(state);
	return additionalSurveys.convertedReadingsByTimeuuid[timeuuid];
};

const selectDatFilesByTimeuuid = state => {
	const additionalSurveys = selectSliceAdditionalSurveys(state);
	return additionalSurveys?.datFilesByTimeuuid;
};

const _listFileKeys = (MasterLST = []) =>
	Object.keys(MasterLST).filter(v => v && v !== 'size' && v !== 'length');

const _getMasterLSTTimeuuid = (MasterLST = {}) => {
	const fileKeys = _listFileKeys(MasterLST);
	return MasterLST[fileKeys[0]]?.timeuuid;
};

/** ************************
 * PUBLIC SELECTORS
 */

export const selectThisTimeuuid = state => {
	const { MasterLST } = selectJobGlobalData(state);
	const timeuuid = _getMasterLSTTimeuuid(MasterLST);
	return timeuuid;
};

export const selectMasterLSTFileMetaFromGpsFilePath = (state, gpsFilePath) => {
	const { MasterLST } = selectJobGlobalData(state);
	const datFilesByTimeuuid = selectDatFilesByTimeuuid(state);
	const pageTimeuuid = selectThisTimeuuid(state);
	const timeuuid = parseTimeuuid(gpsFilePath);
	const fileName = parseOriginalFileName(gpsFilePath);

	if (pageTimeuuid === timeuuid) {
		// return from primary doc
		return MasterLST[fileName];
	}

	// check in slice additional surveys
	return ((datFilesByTimeuuid || {})[timeuuid] || []).find(
		doc => doc.fileName === fileName
	);
};

export const selectReadingsWithIndex = (
	state,
	gpsFilePath,
	fileReadingIndex
) => {
	const file = selectMasterLSTFileMetaFromGpsFilePath(state, gpsFilePath);
	const timeuuid = parseTimeuuid(gpsFilePath);

	const convertedReadingsKeyToIndexesByTimeuuid = selectConvertedReadingsKeyToIndexesByTimeuuid(
		state,
		timeuuid
	);
	const convertedReadingsByTimeuuid = selectConvertedReadingsByTimeuuid(
		state,
		timeuuid
	);

	const fileReading = file.gpsreadings.at(fileReadingIndex);
	const readingIndex = getIndex(
		convertedReadingsKeyToIndexesByTimeuuid,
		fileReading
	);

	const reading = convertedReadingsByTimeuuid.at(readingIndex);

	return { ...reading, readingIndex };
};
